module.exports = __webpack_public_path__ + "static/room-block-6-f2edf79fe35be184b10dcfab576bd167.svg";